<ds-alert [variant]="'timeout'" [size]="'s'" [formMode]="false">
  <span class="ds-alert__text">
    {{ expireWarningKey | translate }}
    <ds-badge
      [variant]="'counter'"
      [size]="'s'"
      [rounded]="true"
      [asIndicator]="false"
      [withIcon]="false">
      {{ seconds() | duration}}</ds-badge>
  </span>
</ds-alert>
